<div class="pt-5 bg-white">
    <div class="row ml-0">
        <div class="col-1"></div>
        <div class="col-10">
            <div class="header-content">Languages</div>
            <div class="sub-content mt-3">Manage app translation content for each language.</div>
        </div>
        <div class="col-1"></div>
    </div>
</div>

<div class="row ml-0 mt-4">
    <div class="col-1"></div>
    <div class="col-10">
        <table class="language-table w-100" *ngIf="languageList.length">
            <thead>
                <tr>
                    <th>Language</th>
                    <th>Code</th>
                    <th>Status</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let lang of languageList">
                    <td>{{ lang.language_name }}</td>
                    <td>{{ lang.language_code }}</td>
                    <td>
                        <span class="status-badge" [ngClass]="lang.status === 'active' ? 'badge-active' : 'badge-expired'">
                            {{ lang.status }}
                        </span>
                    </td>
                    <td>{{ lang.updated_at || lang.created_at }}</td>
                    <td>
                        <button class="btn btn-sm action-btn" (click)="viewLanguage(lang)" title="View / Edit">
                            <mat-icon class="font-18">edit</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="sub-content mt-5 text-center" *ngIf="!languageList.length">
            No language content yet.
        </div>
    </div>
    <div class="col-1"></div>
</div>
